<ng-container *ngIf="isLoaderVisibleSubject">
  <ng-container *ngIf="isLoaderVisibleSubject | async">
    <div class="overlay">
      <sit-spinner></sit-spinner>
    </div>
  </ng-container>
</ng-container>
